import { createDomain } from 'effector-root';

const domain = createDomain('PrintMap (Page)');

export const onPageStarted = domain.event();